/**
 * Validação do título de eleitor brasileiro (formato + dígitos verificadores).
 * Formato: 12 dígitos = 8 sequencial + 2 UF (01–28) + 2 dígitos verificadores.
 */
export function isValidTituloEleitor(raw: string): boolean {
  const t = (raw || '').replace(/\D/g, '')
  if (t.length !== 12) return false

  const uf = t.substring(8, 10)
  const ufNum = parseInt(uf, 10)
  if (ufNum < 1 || ufNum > 28) return false // UFs válidas: 01–28
  const isSpMg = uf === '01' || uf === '02' // caso especial SP/MG

  // DV1 — 8 dígitos sequenciais × pesos 2..9
  let s1 = 0
  for (let i = 0; i < 8; i++) s1 += parseInt(t[i], 10) * (i + 2)
  let d1 = s1 % 11
  if (d1 === 10) d1 = 0
  if (d1 === 0 && isSpMg) d1 = 1

  // DV2 — UF (2 dígitos) + DV1 × pesos 7,8,9
  const base2 = uf + d1
  const w2 = [7, 8, 9]
  let s2 = 0
  for (let i = 0; i < 3; i++) s2 += parseInt(base2[i], 10) * w2[i]
  let d2 = s2 % 11
  if (d2 === 10) d2 = 0
  if (d2 === 0 && isSpMg) d2 = 1

  return t.substring(10, 12) === `${d1}${d2}`
}
